import { get } from "./localStorage";
import awsBasedAgencies from "../constants/aws_based_agencies.json";
import { getConfig } from "../config";

/**
 * Generates the appropriate API URL based on the agency name in localStorage
 * @param {string} endpoint - The API endpoint path
 * @returns {string} The full API URL
 */
export function getApiUrl(endpoint, email = null) {
  const agencyEmail = email || get("email");
  let baseUrl = getConfig().authBaseUrl;

  if (agencyEmail) {
    const emailLower = agencyEmail.toLowerCase();
    const emailDomain = emailLower.split("@")[1];

    for (const [agencyId, agencyData] of Object.entries(awsBasedAgencies)) {
      if (agencyData.emails.includes(emailLower)) {
        baseUrl = agencyData.url;
        break;
      }
      if (agencyData.domains.includes(emailDomain)) {
        baseUrl = agencyData.url;
        break;
      }
    }
  }

  return `${baseUrl}${endpoint}`;
}
